import lottie from 'lottie-web';

document.addEventListener('DOMContentLoaded', () => {
  // Alle Animationen initialisieren
  document.querySelectorAll('.lottie-animation').forEach(container => {
    const path = container.getAttribute('data-animation-path');
    if (path) {
      lottie.loadAnimation({
        container,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: `/fileadmin/animated_svg/${path}`
      });
    }
  });

  // Nach einer kurzen Verzögerung zum Anker scrollen
  setTimeout(() => {
    if (window.location.hash) {
      const target = document.querySelector(window.location.hash);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, 500); // Passe die Verzögerung je nach Ladezeit der Animationen an
});


// SVG Interaktionen und Modals verwalten
document.addEventListener('DOMContentLoaded', () => {
  // Alle Modals von der .active-Klasse befreien
  document.querySelectorAll('.svg-modal').forEach(modal => {
    modal.classList.remove('active');
  });

  document.querySelectorAll('.interactive-svg').forEach(svgContainer => {
    // Initialen Trigger entfernen
    const initialTrigger = svgContainer.querySelector('#trigger-1');
    if (initialTrigger) {
      svgContainer.querySelectorAll('g').forEach(g => g.classList.remove('active'));
      initialTrigger.classList.add('active');
      reorderSVG(svgContainer);

      // Stelle sicher, dass der Initialtrigger keine modale .active-Klasse hat
      const triggerIndex = parseInt(initialTrigger.id.replace('trigger-', '')) - 1;
      svgContainer.querySelectorAll('.svg-modal').forEach((modal, index) => {
        if (index === triggerIndex) {
          modal.classList.remove('active'); // Initial nicht aktiv setzen
        }
      });
    }
  });
});

// Klicks auf SVGs und Modals verwalten
document.addEventListener('click', function(event) {
  const isClickInsideSvgModal = (event.target as HTMLElement).closest('.svg-modal');
  const isClickInsideModalBox = (event.target as HTMLElement).closest('.modal-box');

  if (isClickInsideSvgModal && !isClickInsideModalBox) {
    document.querySelectorAll('.svg-modal').forEach(modal => modal.classList.remove('active'));
    const body = document.querySelector('body');
    if(body!=null){
      body.style.paddingRight="0px"
    }
  }
});

document.querySelectorAll('.interactive-svg g').forEach(trigger => {
  trigger.addEventListener('click', () => {
    if (trigger.id.startsWith('trigger-')) {
      const svgContainer = trigger.closest('.interactive-svg')!;
      svgContainer.querySelectorAll('g').forEach(g => g.classList.remove('active'));
      trigger.classList.add('active');
      reorderSVG(svgContainer);

      const triggerIndex = parseInt(trigger.id.replace('trigger-', '')) - 1;
      svgContainer.querySelectorAll('.svg-modal').forEach((modal, index) => {
        const body = document.querySelector('body');
        if (body != null && index === triggerIndex) {
          const widthBefore = body.offsetWidth;
          
          // Toggling modal class based on the condition
          modal.classList.toggle('active', index === triggerIndex);
          
          const widthAfter = body.offsetWidth;
          
          // Correct way to update the body width using string interpolation and px unit
          console.log(`${widthBefore - widthAfter}px`)
          body.style.paddingRight = `${widthAfter - widthBefore}px`;
        }

      });
    }
  });
});

// Alle Modals schließen
document.querySelectorAll('.svg-modal-close').forEach(closeButton => {
  closeButton.addEventListener('click', () => {
    document.querySelectorAll('.svg-modal.active').forEach(modal => modal.classList.remove('active'));
  });
});

// SVG-Elemente neu anordnen
function reorderSVG(svgElement: SVGSVGElement) {
  const active = svgElement.querySelector('g.active');
  if (active) {
    active.parentNode?.appendChild(active);
  }
}
